import React, { Component } from 'react';
import Measure from 'react-measure';
import StoryMixerGroup from './StoryMixerGroup';

/**
 * A wrapped version of the Story Mixer Group that measures the size of the container.
 * This measurement is used in the Group to determine if the content should displayed as a single column.
 *
 * @class MeasuredStoryMixerGroup
 * @extends {Component}
 */
class MeasuredStoryMixerGroup extends Component {
	constructor(props) {
		super(props);

		this.state = {
			width: 0
		};

		this.onResize = this.onResize.bind(this);
	}

	onResize(contentRect) {
		this.setState({
			width: contentRect.bounds.width
		});
	}

	render() {
		return (
			<Measure bounds onResize={this.onResize}>
				{ ({measureRef}) => (
					<StoryMixerGroup {...this.props} measureRef={measureRef} width={this.state.width} />
				)}
			</Measure>
		);
	}
}

MeasuredStoryMixerGroup.defaultProps = {
	width: 0
}

export default MeasuredStoryMixerGroup;



// WEBPACK FOOTER //
// ./src/react/views/storyMixer/MeasuredStoryMixerGroup.jsx